/* Así funciona · Esquinero de Ducha Ajustable de 4 Repisas (385982)
   Todo sale de la foto real del producto en la esquina de un baño (funciona/esquinero-de-ducha-ajustable-de-4-repisas/
   vaciar.py y hacer.py): la clienta sube el tubo telescópico real (su punta real y su perfil cromado real, estirado a
   lo largo como sale un tubo de otro) hasta que llega al techo y queda fijo a presión; luego toca cada repisa y se
   asientan los frascos reales de la foto (el riel blanco real queda delante), hasta quedar exactamente la foto real.
   Las repisas vacías son la MISMA foto con la pared, el tubo y el plástico de la repisa rehechos con sus propios
   píxeles (sin IA). Al final la cámara baja a la base. Ficha: se fija entre piso y techo sin taladro, 4 repisas
   antideslizantes, base reforzada. */
NHF.escena('esquinero-de-ducha-ajustable-de-4-repisas', function (E) {
  const D = /*DATOS*/{"base":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-base.webp","caja":[0,0,1600,1440]},"punta":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-punta.webp","caja":[727,223,23,11]},"tubo":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-tubo.webp","x":727,"w":23,"y0":233},"tope":224,"repisas":[{"k":1,"par":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-par1.webp","caja":[669,392,141,144]},"borde":533.5,"riel":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-riel1.webp","caja":[663,484,153,8]},"lleno":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-lleno1.webp","caja":[659,383,163,161]},"toque":[585,330,310,238],"techo":300},{"k":2,"par":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-par2.webp","caja":[676,594,131,144]},"borde":735.5,"riel":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-riel2.webp","caja":[670,680,143,9]},"lleno":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-lleno2.webp","caja":[664,585,151,161]},"toque":[585,572,310,196],"techo":568},{"k":3,"par":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-par3.webp","caja":[656,797,151,165]},"borde":959.0,"riel":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-riel3.webp","caja":[650,906,163,8]},"lleno":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-lleno3.webp","caja":[643,778,176,192]},"toque":[585,770,310,222],"techo":763},{"k":4,"par":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-par4.webp","caja":[656,1014,160,170]},"borde":1181.0,"lleno":{"src":"fn-esquinero-de-ducha-ajustable-de-4-repisas-lleno4.webp","caja":[645,1004,181,188]},"toque":[585,994,310,214],"techo":990}],"pie":[430,900,620,540]}/*FIN*/;
  const S = E.lienzo({ w: 1600, h: 1440, vista: [100, 0, 1400, 1440], vistaMovil: [300, 40, 900, 1360] });
  const movil = () => window.innerWidth < 760;
  E.titulo('Del piso [al techo].', 'Sube el tubo hasta el techo: queda fijo sin taladro. Luego llena sus 4 repisas.');
  E.conSonido();
  S.cargando(true);

  /* ---------- capas (todas de la foto real) ---------- */
  S.img(D.base.src, D.base.caja, { z: 1, alt: 'Esquinero de ducha de 4 repisas en la esquina de un baño' });
  const tubo = S.img(D.tubo.src, [D.tubo.x, D.tope + 9, D.tubo.w, 0], { z: 3 });
  const punta = S.img(D.punta.src, D.punta.caja, { z: 4 });
  const R = D.repisas.map(r => {
    const env = S.div([0, 0, 1600, 1440], { z: 10 + r.k });
    env.style.clipPath = "inset(" + r.techo + "px 0 " + (1440 - r.borde - 1) + "px 0)";
    const par = S.img(r.par.src, r.par.caja, { en: env, opacidad: 0 });
    const riel = r.riel ? S.img(r.riel.src, r.riel.caja, { z: 20 + r.k, opacidad: 0 }) : null;
    const lleno = S.img(r.lleno.src, r.lleno.caja, { z: 30 + r.k, opacidad: 0 });
    const o = { r, par, riel, lleno, puesto: false };
    o.toque = S.toque(r.toque, { etiqueta: 'Repisa ' + r.k + ': pon tus frascos', alTocar: () => poner(o) });
    return o;
  });
  E.cargar([D.base.src, D.tubo.src, D.punta.src].concat(D.repisas.map(r => r.par.src))).then(() => S.cargando(false));

  /* ---------- estado y panel ---------- */
  const TECHO = -34;            // la punta pasa del borde de la foto: llegó al techo
  const RESORTE = 70;           // cerca del techo, el resorte del tubo lo lleva solo hasta arriba
  const ST = { tope: D.tope, fijo: false, puestos: 0, subiendo: false, fin: false };
  E.pasos(['Sube el tubo hasta el techo', 'Llena sus 4 repisas']);
  E.paso(0);
  const lect = E.lectura({ etiqueta: 'Tubo' }); lect.poner('Suelto');
  const bAuto = E.boton('Súbelo por mí', () => (ST.fijo ? llenarTodas() : subirSolo()), { icono: 'toca' });
  E.nota('Se ajusta del piso al techo sin taladro. 4 repisas antideslizantes y base reforzada.');

  /* ---------- el tubo telescópico ---------- */
  const zona = S.toque([D.tubo.x - 90, D.tope - 120, D.tubo.w + 180, 230], { etiqueta: 'Tubo: súbelo hasta el techo', clase: 'eq-tubo' });
  zona.style.touchAction = 'none'; zona.style.cursor = 'ns-resize';
  zona.classList.add('is-pista');
  function ponerTope(y) {
    ST.tope = E.clamp(y, TECHO, D.tope);
    punta.style.transform = 'translate3d(0,' + (ST.tope - D.tope).toFixed(1) + 'px,0)';
    const t0 = ST.tope + 9, alto = D.tope - ST.tope;
    tubo.style.top = t0.toFixed(1) + 'px';
    tubo.style.height = Math.max(0, alto).toFixed(1) + 'px';
    zona.style.top = Math.max(ST.tope - 120, 0) + 'px';
  }
  ponerTope(D.tope);
  let ini = null, movido = 0;
  zona.addEventListener('pointerdown', e => {
    if (ST.fijo || ST.subiendo) return;
    try { zona.setPointerCapture(e.pointerId); } catch (x) {}
    const p = S.punto(e); ini = { y: p.y, tope: ST.tope }; movido = 0;
    zona.classList.remove('is-pista'); S.el.classList.add('is-tocado');
  });
  zona.addEventListener('pointermove', e => {
    if (!ini || ST.fijo) return;
    const p = S.punto(e), d = (p.y - ini.y) * 1.2;
    movido = Math.max(movido, Math.abs(d));
    ponerTope(ini.tope + d);
    if (ST.tope <= RESORTE) { ini = null; fijar(); }
  });
  const soltar = () => {
    if (!ini) return; ini = null;
    if (ST.fijo) return;
    if (movido > 8) S.pista(ST.tope < D.tope - 4 ? 'Sigue: súbelo hasta el techo' : 'Arrastra el tubo hacia arriba', 'mano');
  };
  zona.addEventListener('pointerup', soltar); zona.addEventListener('pointercancel', soltar);
  zona.addEventListener('click', () => { if (movido <= 8 && !ST.fijo) subirSolo(); });
  zona.addEventListener('keydown', e => { if (e.key === 'ArrowUp' && !ST.fijo) { e.preventDefault(); ponerTope(ST.tope - 40); if (ST.tope <= RESORTE) fijar(); } });
  async function subirSolo() {
    if (ST.fijo || ST.subiendo) return;
    ST.subiendo = true; zona.classList.remove('is-pista');
    const y0 = ST.tope;
    await E.animarP(1100, k => ponerTope(E.lerp(y0, RESORTE, k)), E.suave);
    ST.subiendo = false;
    fijar();
  }
  async function fijar() {
    if (ST.fijo) return;
    ST.fijo = true; zona.style.pointerEvents = 'none';
    const y0 = ST.tope;
    await E.animarP(220, k => ponerTope(E.lerp(y0, TECHO, k)), E.salida);
    E.sonido.clic(); E.sonido.tono(820, .06, .04); E.vibrar(14);
    lect.etiqueta('Repisas llenas'); lect.poner('0', 'de 4');
    E.paso(1);
    bAuto.texto('Llénalas por mí');
    S.pista('¡Fijo! Ahora toca cada repisa', 'toca');
    if (movil()) S.camara([420, 360, 640, 960], 900);
    marcarSiguiente();
  }

  /* ---------- las repisas ---------- */
  function marcarSiguiente() {
    const sig = R.slice().reverse().find(o => !o.puesto);
    R.forEach(o => o.toque.classList.toggle('is-pista', o === sig));
  }
  async function poner(o) {
    if (ST.fin) return;
    if (!ST.fijo) { S.pista('Primero sube el tubo hasta el techo', 'mano'); zona.classList.add('is-pista'); E.sonido.tono(300, .08, .04); return; }
    if (o.puesto) return;
    o.puesto = true; o.toque.classList.remove('is-pista'); o.toque.style.pointerEvents = 'none';
    const p = o.par, BAJA = 26;
    p.style.transition = 'none'; p.style.opacity = '0'; p.style.transform = 'translate3d(0,' + (-BAJA) + 'px,0)';
    if (o.riel) o.riel.style.opacity = '1';
    void p.offsetWidth;
    p.style.transition = 'transform .5s cubic-bezier(.25,.9,.3,1), opacity .1s linear';
    p.style.opacity = '1'; p.style.transform = 'translate3d(0,0,0)';
    await E.esperar(480);
    E.sonido.tono(1250 - o.r.k * 90, .05, .03); E.vibrar(8);
    o.lleno.style.transition = 'opacity .3s'; o.lleno.style.opacity = '1';
    await E.esperar(320);
    if (o.riel) o.riel.style.opacity = '0';
    ST.puestos++;
    lect.poner(String(ST.puestos), 'de 4');
    if (ST.puestos >= 4) terminar();
    else { S.pista('Sigue: toca otra repisa', 'toca'); marcarSiguiente(); }
  }
  async function llenarTodas() {
    bAuto.hidden = true;
    for (const o of R.slice().reverse()) { if (!o.puesto) { await poner(o); await E.esperar(160); } }
  }
  async function terminar() {
    ST.fin = true; bAuto.hidden = true;
    E.paso(2);
    S.pista('Base reforzada: se apoya firme en el piso', 'toca');
    await S.camara(D.pie, 1000);
    await E.esperar(1500);
    await S.camara(null, 1000);
    S.pista(null);
    E.listo('Queda firme entre piso y techo, sin taladro, con 4 repisas para lo tuyo.', reiniciar);
  }

  /* ---------- ver de nuevo ---------- */
  async function reiniciar() {
    E.noListo();
    ST.fin = false; ST.puestos = 0;
    R.forEach(o => {
      o.puesto = false; o.lleno.style.transition = 'opacity .35s'; o.lleno.style.opacity = '0';
      o.par.style.transition = 'opacity .35s'; o.par.style.opacity = '0'; o.toque.style.pointerEvents = 'auto'; o.toque.classList.remove('is-pista');
    });
    S.camara(null, 700);
    const y0 = ST.tope;
    await E.animarP(700, k => ponerTope(E.lerp(y0, D.tope, k)), E.suave);
    ST.fijo = false; zona.style.pointerEvents = 'auto'; zona.classList.add('is-pista');
    lect.etiqueta('Tubo'); lect.poner('Suelto');
    bAuto.hidden = false; bAuto.texto('Súbelo por mí');
    E.pasos(['Sube el tubo hasta el techo', 'Llena sus 4 repisas']); E.paso(0);
    S.pista('Arrastra el tubo hacia arriba', 'mano');
  }
  S.pista('Arrastra el tubo hacia arriba', 'mano');
});
